import { render, staticRenderFns } from "./SignUpDetail.vue?vue&type=template&id=5b306480&scoped=true"
import script from "./SignUpDetail.vue?vue&type=script&lang=js"
export * from "./SignUpDetail.vue?vue&type=script&lang=js"
import style0 from "./SignUpDetail.vue?vue&type=style&index=0&id=5b306480&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b306480",
  null
  
)

export default component.exports